<template>
  <div class="comment-article">
    <div class="header">
      <span>精彩留言<i>（{{ total }}条）</i></span>
      <img src="../../assets/icons/comment.png" alt="comment" @click="$emit('reply')"/>
    </div>

    <dl v-for="(item, index) in list" :key="`c${index}`">
      <dt><img :src="item.pic"/></dt>
      <dd>
        <div class="top">
          <span>{{item.userName}} <template v-if="item.userLearnDays">坚持阅读:{{item.userLearnDays}}天</template></span>
          <span @click="$emit('praise', item.id, index)">
            <img
              :src="item.isLike ? require('../../assets/icons/article-liked-orange.png') : require('../../assets/icons/article-like.png')"/>
              <i :style="{ color: item.isLike ? '#FF9C51' : '#979797'}">{{item.score}}</i>
          </span>
        </div>
        <p>
          {{item.restext}}
        </p>

        <div v-if="item.replyList.length">
          <div class="reply" v-for="(item, index) in item.replyList" :key="`r${index}`">
            <p>老师&emsp;回复&emsp;{{ item.replyName }}</p>
            <p>{{ item.restext }}</p>
          </div>
        </div>
      </dd>
    </dl>
  </div>
</template>

<script>
import AppButton from '../UI/Button'

export default {
  components: {
    AppButton
  },

  props: ['list', 'total']
}
</script>

<style lang="scss" scoped>
@charset "UTF-8";
@import "../../style/main";

.comment-article {
  width: 100%;
  padding: 0 rem(43);
  box-sizing: border-box;
  background-color: #F8F8F8;
  overflow: hidden;

  &:after {
    content: '';
    display: block;
    height: 0;
    overflow: hidden;
    font-size: 0;
    clear: both;
  }

  .header {
    width: 100%;
    height: rem(84);
    margin-top: rem(19);
    margin-bottom: rem(28);

    span {
      float: left;
      font-size: rem(28);
      line-height: rem(84);

      i {
        color: #DDB58B;
        font-size: rem(24);
      }
    }

    img {
      float: right;
      height: rem(56);
      width: rem(180);
    }
  }

  dl {
    width: rem(663);
    margin-bottom: rem(50);
    overflow: hidden;

    dt {
      float: left;
      width: rem(70);
      margin-right: rem(25);

      img {
        height: rem(70);
        width: rem(70);
        border-radius: rem(10);
        margin: 0;
      }
    }

    dd {
      float: left;
      width: rem(568);

      .top {
        height: rem(33);
        width: rem(568);
        margin-bottom: rem(7);

        span {
          float: right;
          font-size: rem(24);
          line-height: rem(33);

          &:first-child {
            float: left;
            color: #CE9253;
          }

          &:last-child {

            img {
              height: rem(29);
              width: rem(29);
              margin: 0;
              margin-right: rem(5);
              vertical-align: middle;
            }

            i {
              vertical-align: middle;
            }
          }
        }
      }

      p {
        width: rem(550);
        color: #4B321C;
        font-size: rem(28);
        line-height: rem(40);
        margin-bottom: rem(14);
      }

      .reply {
        width: rem(580);
        background-color: #EFEFEF;
        padding: rem(22);
        box-sizing: border-box;
        border-radius: rem(10);

        p:first-child {
          color: #999;
          font-size: rem(24);
          margin-bottom: rem(14);
        }

        p:last-child {
          width: 100%;
          word-break: normal;
          color: #4B321C;
          font-size: rem(28);
          line-height: rem(40);
        }
      }
    }
  }
}

</style>
